import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
if (environment.production) {
    enableProdMode();
}
import Amplify from '@aws-amplify/core';
import awsconfig from './aws-exports';
import * as __NgCli_bootstrap_1 from "./app/app.module.ngfactory";
import * as __NgCli_bootstrap_2 from "@angular/platform-browser";
const redirectSignInOptions = awsconfig.oauth.redirectSignIn.split(',');
const ɵ0 = s => s.startsWith('https'), ɵ1 = s => s.includes('localhost');
const redirect = environment.production
    ? redirectSignInOptions.find(ɵ0)
    : redirectSignInOptions.find(ɵ1);
awsconfig.oauth.redirectSignIn = redirect;
awsconfig.oauth.redirectSignOut = redirect;
Amplify.configure(awsconfig);
__NgCli_bootstrap_2.platformBrowser().bootstrapModuleFactory(__NgCli_bootstrap_1.AppModuleNgFactory);
export { ɵ0, ɵ1 };
